module.exports = __webpack_public_path__ + "img/expenses.cb76efcf.svg";